import * as React from 'react'
import { mount } from 'enzyme'
import moment from 'moment'
import RcCalendar from 'rc-calendar'
import { Calendar } from '../index'
import { TextInput } from '../../TextInput'

const NOW = moment()
const DATE_FORMAT = 'YYYY-MM-DD'
const NOW_FORMATTED = moment().format(DATE_FORMAT)
const NAME = 'name'

describe('Calendar', () => {
  let calendar
  const onChange = jest.fn()
  beforeAll(() => {
    calendar = mount(
      <Calendar name={NAME} dateFormat={DATE_FORMAT} onChange={onChange} />,
    )
  })
  beforeEach(() => jest.clearAllMocks())
  it('set value', () => {
    calendar.setProps({ value: NOW })
    expect(calendar.find(TextInput)).toHaveProp('value', NOW_FORMATTED)
  })

  it('select date', () => {
    const selectedDate = moment(NOW).date(1)

    calendar.find(TextInput).simulate('click')
    calendar.setProps({ value: NOW })
    setTimeout(() => {
      // rc-calendar issue
      calendar.find('.rc-calendar-date').forEach(date => {
        if (date.text() === '1') {
          date.simulate('click')
        }
      })

      expect(onChange).toBeCalledWith(selectedDate, NAME)
      expect(calendar.state('isOpen')).toBeFalsy()
    }, 0)
  })

  it('open calendar', () => {
    calendar.find(TextInput).simulate('click')
    calendar.setProps({ value: NOW })

    expect(calendar.state('isOpen')).toBeTruthy()
    expect(calendar.find(RcCalendar)).toHaveLength(1)
  })

  it('outside click close', () => {
    calendar.find(TextInput).simulate('click')
    calendar.instance().onDocumentMouseDown({
      target: document,
    })
    expect(calendar.state('isOpen')).toBeFalsy()
  })
})
